<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="!loaded ? '' : user?.first_name"
      [canGoBack]="true"
      [customBack]="windowService.isDesktopRes ? 'more/users' : 'users'"
      (linkAction)="deleteUser()"
      [showLinkIcon]="loaded && user?.role !== 'owner'"
      [linkIcon]="'trash'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
          <tidy-image
            [src]="'assets/img/account.svg'"
            class="header-size" />
          <tidy-text
            [header]="user?.first_name + ' ' + user?.last_name"
            [translate]="false" />
          <tidy-text
            [body]="'Edit'"
            class="link"
            (action)="goToEditUserDetailsPage()" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/img/email.svg'"
            class="body-size" />
          <tidy-text
            [helper]="user?.email"
            [translate]="false" />
        </tidy-row>
        @if (user?.phone) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/call-grey.svg'"
              class="body-size" />
            <tidy-text
              [helper]="user?.phone | telephone:'format'" />
          </tidy-row>
        }
        @if (clientInfo?.customer_account?.account_type !== 'regular') {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/information-circle-grey.svg'"
              class="body-size" />
            <tidy-text
              [helper]="'User Type:'" /><span>&nbsp;</span>
              <tidy-text
                [helper]="role" />
            </tidy-row>
            @if (user?.role !== 'owner') {
              <tidy-row class="extra-top-padding extra-bottom-padding">
                <tidy-divider />
              </tidy-row>
            }
            @if (user?.role === 'admin') {
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [helper]="'This user can see all properties and users.'" />
              </tidy-row>
            }
            @if (user?.role === 'member') {
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [helper]="'This user can only see properties and group members on their group.'" />
              </tidy-row>
            }
          }
        </tidy-card>
        @if (user?.role !== 'owner' && clientInfo?.customer_account?.account_type !== 'regular') {
          <tidy-card>
            <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/organization.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Groups'" />
              <tidy-text
                [body]="'Add to Group'"
                class="link"
                (action)="goToAddUserToTeamPage()" />
            </tidy-row>
            @for (team of teamsUserIsOn; track team) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [body]="team?.name"
                  (action)="goToTeamPage(team?.team_id)"
                  class="link"
                  [translate]="false" />
                <tidy-text
                  [body]="'X'"
                  class="link"
                  (action)="removeFromTeam(team?.team_member_id)" />
              </tidy-row>
            }
            @if (teamsUserIsOn?.length == 0) {
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [helper]="'Not on any groups'" />
              </tidy-row>
            }
          </tidy-card>
        }
        @if (user?.role !== 'owner' && user?.role !== 'admin') {
          <tidy-card>
            <tidy-row class="extra-bottom-padding vertical-align-center">
              <tidy-image
                [src]="'assets/img/home.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Properties'" />
            </tidy-row>
            @for (address of userAddresses; track address) {
              <tidy-row class="vertical-align-middle">
                <tidy-image
                  [src]="'assets/img/location.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="address"
                  [translate]="false" />
              </tidy-row>
            }
            @if (!userAddresses?.length) {
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [helper]="'No properties assigned'" />
              </tidy-row>
            }
          </tidy-card>
        }
        @if (isRightSideContent) {
          <tidy-row [align]="'center'">
            <tidy-text
              class="link red"
              [body]="'Delete User'"
              (action)="deleteUser()" />
          </tidy-row>
        }
      }

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

    </tidy-wrapper>
  </ng-template>


  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
